type CartLine = { id: number; selectedCount: number };

/** Confirmed UserWeekReserve on server — not basket.pending */
export function getServerReserveCount(reserve: UserWeekReserveEntity): number {
  if (reserve.id == null) {
    return 0;
  }
  return Math.max(0, reserve.selectedCount ?? 0);
}

export function getProgramCartCount(cartPrograms: ReadonlyArray<CartLine>, programId: number): number {
  return cartPrograms.find(p => p.id === programId)?.selectedCount ?? 0;
}

/** UI total: server reserve + pending cart lines for the same program */
export function getCombinedDisplayCount(
  reserve: UserWeekReserveEntity,
  cartPrograms: ReadonlyArray<CartLine>,
): number {
  return getServerReserveCount(reserve) + getProgramCartCount(cartPrograms, reserve.programId);
}
